// extracted by mini-css-extract-plugin
export default {"description":"Tooltip_description__Rmy9s","shortcut":"Tooltip_shortcut__AsY9y"};